import { createContext } from 'react';
import HotelService from '../Services/HotelService';

const HotelContext = createContext<HotelService>(new HotelService());

export default HotelContext;
